import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { ErrorModel } from '@era/app';
import { VppApplication } from './vpp-applications.state';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const VppApplicationsResolverActions = createActionGroup({
  source: 'Vpp applications resolver',
  events: {
    'Vpp applications requested': emptyProps(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ApplicationsApiActions = createActionGroup({
  source: 'Applications API',
  events: {
    'Vpp applications loaded': props<{ applications: VppApplication[] }>(),
    'Vpp applications loaded error': props<{ error: ErrorModel }>(),
  },
});
